import React from "react";
import { Text } from "src/sudokit/components/Text";
import MenuSelect from "src/sudokit/components/SudoSelect/MenuSelect";
import { IMAGE_GENERATION_MODELS, imageGenerationModelHonorsAspectRatio } from "~shared/imageGenerationModels";

const SELECTABLE_MODELS = IMAGE_GENERATION_MODELS.filter((m) => m.selectable);

export const modelSupportsReferenceImage = (modelValue: string): boolean =>
  IMAGE_GENERATION_MODELS.find((m) => m.id === modelValue)?.supportsReferenceImage ?? false;

interface ModelSelectProps {
  value: string;
  onChange: (value: string) => void;
  /** Drop models that ignore aspect_ratio (worldbuilding / cover surfaces). */
  aspectRatioAware?: boolean;
  helpText?: string;
}

const ModelSelect: React.FC<ModelSelectProps> = ({ value, onChange, aspectRatioAware = false, helpText }) => {
  const models = aspectRatioAware ? SELECTABLE_MODELS.filter((m) => imageGenerationModelHonorsAspectRatio(m.id)) : SELECTABLE_MODELS;
  const options = models.map((m) => ({ value: m.id, label: `${m.label} (${m.providerLabel})` }));

  return (
    <div className="flex flex-col items-start gap-2 w-full text-left">
      <Text size="sm" weight="medium">
        Model
      </Text>
      <MenuSelect options={options} value={value} onChange={onChange} label="Model" variant="secondary" menuSide="top" menuAlign="start" />
      {helpText && (
        <Text size="xs" color="grey-1">
          {helpText}
        </Text>
      )}
    </div>
  );
};

export default ModelSelect;
